/**
 * Empreinte SHA-256 d'une chaîne, en hexadécimal.
 * Utilisé pour tracer le contenu exact d'un document au moment de sa signature.
 * Repli sur une chaîne vide si l'API n'est pas disponible (contexte non sécurisé).
 */
export const sha256 = async (value: string): Promise<string> => {
  if (!window.crypto?.subtle) return "";
  const bytes = new TextEncoder().encode(value);
  const digest = await window.crypto.subtle.digest("SHA-256", bytes);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
};
